import {SET_SIGNUP_CONFIG} from "../actions/const";

const initialState = {
  resetState: false,
  showModal: false,
  isLoadingAction: false,

  showModalConfig: false,
  isSavingConfig: false,
  isLoadingConfig: false,
  isActive: false,
  switch_parseObject: null,

  isLoading: false,
  browser_parseObject: null,
  browser: null,
  browserOptions: [
    {
        label: "INTERNAL",
        value: "INTERNAL"
    },
    {
        label: "EXTERNAL",
        value: "EXTERNAL"
    }
  ],

  url_parseObject: null,
  url: "",

  isEnabledIOS_parseObject: null,
  isEnabledIOS: false,

  isEnabledAndroid_parseObject: null,
  isEnabledAndroid: false,

  politicallyExposedPerson_parseObject: null,
  politicallyExposedPerson: "",

  membershipAgreement_parseObject: null,
  membershipAgreement: "",

  dataPrivacyPolicy_parseObject: null,
  dataPrivacyPolicy: ""
};

function reducer (state = initialState, action) {
  let { type, payload } = action;

  switch (type) {
    case SET_SIGNUP_CONFIG:
      if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
        action.payload = {...initialState};
      }
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/SignUpConfig.js